/* global System */
// register component(s) with react habitat

export default {
  CustBarVC: () =>
    System.import(
      /* webpackChunkName: "CustBarVC" */
      './Component'
    ),
}
